import styled, { css } from "styled-components";

import { Button, TextField } from "@material-ui/core";
import { UserInputFieldsProps } from "../../create-user/types";

const FlexAndGap = css`
  display: flex;
  gap: 1rem;
`;

const disableEffect = () => {
  return css`
    pointer-events: none;

    input,label {
      color: #e2e1e1;
    }

    fieldset{
      border-color: #e2e1e1;
    }
  `
}

const handleReturnedColor = (hasError: Object | undefined, returnFalse: string) => {
  return hasError ? 'red' : returnFalse;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-bottom: 1rem;

  form {
    padding: 1rem; 

    > div {
      margin: 2rem 0rem;
    }
  
    hr { 
      background-color: #C5C0C0;
    }

    @media(max-width: 730px) {
     
        button:last-child {
          max-width: 100% ;
        }
      
    }
  }
`;

export const StyledButton = styled(Button)`
&& {
  padding: 0.3rem 1.5rem;
  background-color: #0D3EFB;
  color: #fff;
  max-width: 10rem;
  width: 100%;

  :hover, :focus {
    background-color: #3C2EE3;
  }

  :active {
    background-color: #223B6B;
  }
}
`

type TextFieldTypes = Pick<UserInputFieldsProps, "$gridArea" | "$hasError">;
type DisabledField = { $isDisabled?: boolean };
type TextFieldProps = TextFieldTypes & DisabledField;

function handleAnimateInputPasswordWithAnError (inputName: string, hasError: Object) {
  return ['password1', 'password2'].includes(inputName) && hasError ? 'shake 1s ease' : 'none';
}

export const StyledTextField = styled(TextField) <TextFieldProps>`
  width: 100%;
  max-width: 20rem;
  animation: ${({ $gridArea, $hasError }) => handleAnimateInputPasswordWithAnError($gridArea!, $hasError!)}; 

  :focus-within {
    color: #0D3EFB;
  }

  
  && {
    label, input {
      color: ${props => handleReturnedColor(props.$hasError, 'inherit')};
    }

    ${props => props.$isDisabled && disableEffect()}

    input:hover ~ fieldset {
      border-color: ${props => handleReturnedColor(props.$hasError, 'inherit')};
    }

    div {
      :focus-within {
        border-color: ${props => handleReturnedColor(props.$hasError, '#0D3EFB')};
        color: ${props => handleReturnedColor(props.$hasError, '#0D3EFB')};
      }

      fieldset {
        border-color: ${props => handleReturnedColor(props.$hasError, '#A2A7AC')};
      }

      input:focus ~ fieldset {
        border-color: inherit;

        legend {
          color: inherit;
        }
      }
    }
  }

  @media (max-width: 880px) {
    grid-area: ${props => props.$gridArea};
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
}
`;

export const NameEmailWrapper = styled.div`
  ${FlexAndGap};

  @media(max-width: 880px){
    flex-direction: column;

    div { 
      max-width: 100%;
    }
  }
`;

export const UserInfoWrapper = styled.div`
  display: flex;
  gap: 1rem;
  
  @media  (max-width: 880px) {
    display: grid;
    grid-template-areas: 'username username' 'password1 password2';

    > div {
      max-width: 100%;
    }
  }

  @media (max-width: 599px) {
    grid-template-areas: 'username' 'password1' 'password2';
  }
`;

export const UserStateWrapper = styled.div`
  ${FlexAndGap};

  > div {
    width: 9rem;
  }
`;

export const LetterWrapper = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 2rem;
`;

export const ChannelsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;

  @media (max-width: 1070px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 850px) {
    grid-template-columns: repeat(2, 1fr);
  }

  label {
    span:first-child svg {
      fill: #0D3EFB;
    }

    span:last-child {
      font-weight: 400;
      color: #0D3EFB;
      user-select: none;
    }

    span:not(.Mui-checked) ~ span:last-child {
      color: #A2A7AC;
    }
  }

  label:first-child {
    
    span:first-child svg {
      fill: #3C2EE3;
    }

    span:last-child {
      color: #3C2EE3;
    }

  } 
`;